import fromPairs from 'lodash/fromPairs';
import groupBy from 'lodash/groupBy';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import { arrayOf, func, number } from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'reactstrap';

import BulkToggleControls from '../../../generic/BulkToggleControls';
import { creativeShape } from '../../../prop-types';
import CreativesMediaSet from '../../CreativesMediaSet/CreativesMediaSet';
import { getSizeType } from '../../utils';
import SelectableCreative from '../SelectableCreative';

class CompatibleCreatives extends React.Component {
  constructor(props) {
    super(props);

    this.state = { selection: {} };

    this.getSelectedCreativeIds = this.getSelectedCreativeIds.bind(this);
    this.onSelection = this.onSelection.bind(this);
    this.onToggleAll = this.onToggleAll.bind(this);
  }

  onToggleAll(checked) {
    const { creatives } = this.props;

    const selection = checked
      ? fromPairs(creatives.map(ea => [ea.id, true]))
      : {};

    this.setState({ selection }, () =>
      this.props.onChange({
        target: { selectedCreatives: this.getSelectedCreativeIds() },
      }),
    );
  }

  onSelection(event) {
    const value = event.target.checked;
    const id = Number.parseInt(event.target.dataset.id, 10);

    this.setState(
      ({ selection: prevSelection }) => ({
        selection: { ...prevSelection, [id]: value },
      }),
      () => {
        this.props.onChange({
          target: { selectedCreatives: this.getSelectedCreativeIds() },
        });
      },
    );
  }

  getMediaSets() {
    const { creatives } = this.props;
    const mediaSets = groupBy(creatives, 'mediaSet');
    return sortBy(Object.entries(mediaSets), ([setName]) => setName);
  }

  getSelectedCreativeIds() {
    return Object.entries(this.state.selection)
      .filter(([, selected]) => selected)
      .map(([id]) => Number.parseInt(id, 10));
  }

  render() {
    const { creatives, productId } = this.props;
    const { selection } = this.state;

    const noCreatives = isEmpty(creatives);

    const sets = this.getMediaSets();

    return noCreatives ? (
      <div className="alert alert-warning my-3">
        There are no compatible creatives for this product. Please upload
        creatives to the campaign.
      </div>
    ) : (
      <>
        <div className="d-flex flex-row justify-content-end">
          <BulkToggleControls
            entities={creatives}
            activeEntities={creatives.filter(cr => selection[cr.id])}
            onToggleAll={this.onToggleAll}
          />
        </div>
        <Row
          className="flex mb-3"
          id="compatible-creatives"
          key="compatible-list"
        >
          {sets.map(([setName, setCreatives]) => (
            <Col key={setName} xs="12" xl="6">
              <CreativesMediaSet name={setName} className="mb-2">
                <Container fluid className="p-0">
                  <Row className="mx-n2 align-items-end">
                    {setCreatives.map(cr => (
                      <Col key={cr.id} xs="2" className="px-2 mb-2">
                        <SelectableCreative
                          creative={cr}
                          checked={this.state.selection[cr.id] || false}
                          onChange={this.onSelection}
                          sizeType={getSizeType(cr, productId)}
                        />
                      </Col>
                    ))}
                  </Row>
                </Container>
              </CreativesMediaSet>
            </Col>
          ))}
        </Row>
      </>
    );
  }
}

CompatibleCreatives.propTypes = {
  creatives: arrayOf(creativeShape.isRequired),
  onChange: func.isRequired,
  productId: number.isRequired,
};

CompatibleCreatives.defaultProps = {
  creatives: [],
};

export default CompatibleCreatives;
